import { StackScreenProps } from "@react-navigation/stack";
import { useCallback, useEffect, useState } from "react";
import { View } from "react-native-ui-lib";
import { ActionsRootParamList } from "../../../../types";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import {
  useCancelSale,
  useSaleControllerProvider,
} from "../../utils/sale-controller/hooks";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import { useFlashMessages } from "@towersystems/roam-common-native";
import { useActionBackOrClose } from "../../utils/use-action-back-or-close";

export type CancelSaleScreenProps = StackScreenProps<
  ActionsRootParamList,
  "CancelSaleScreen"
>;

export const CancelSaleScreen = ({ navigation }: CancelSaleScreenProps) => {
  const { sale } = useSaleControllerProvider();
  const { showMessage } = useFlashMessages();
  const [value, setValue] = useState(sale?.note || "");
  const cancelSale = useCancelSale();
  const shouldFocus = useHasTransitionEnded(navigation);

  useActionBackOrClose(navigation);

  const handleOnCancel = useCallback(async () => {
    cancelSale(value)
      .then(() => navigation.getParent()?.goBack())
      .catch((err) => {
        showMessage({
          message: err.message,
          severity: "error",
        });
      });
  }, [cancelSale, value]);

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label="Cancel Sale"
          isAction
          onPress={() => handleOnCancel()}
          size="compact"
        ></Button>
      ),
    });
  }, [handleOnCancel]);

  return (
    <Page scrollable={false}>
      <View style={{ height: "100%" }} flex>
        <TextField
          textarea
          placeholder="Leave a note..."
          value={value}
          onChangeText={(v) => setValue(v)}
          autoFocus={shouldFocus}
        />
      </View>
    </Page>
  );
};
